import React from 'react'
import Link from 'gatsby-link'

const Footer = ({ siteTitle }) => (
  <footer className="footer">
    <div className="container">
      <div className="not-row">
        <div className="col-12 col-12-narrow">
          <h3>Contact us</h3>
          <div className="row">
            <div className="col-4 col-12-mobilep">
              <ul className="labeled-icons">
                <li>
                  <h3 className="icon fa-envelope">
                    <span className="label">Email</span>
                  </h3>
                  <a href="#">support@strategeist.com</a>
                </li>
                <li>
                  <h3 className="icon fa-twitter">
                    <span className="label">Twitter</span>
                  </h3>
                  <a href="https://twitter.com/strategeistgame">
                    @strategeistgame
                  </a>
                </li>
                <li>
                  <h3 className="icon fa-facebook">
                    <span className="label">Facebook</span>
                  </h3>
                  <a href="https://facebook.com/strategeist">Facebook</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="copyright">
      &copy; Galactic Starfish. All rights reserved.
    </div>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js